import {
  GET_ALL_STUDENTS,
  GET_ALL_STUDENTS_SUCCESS,
  GET_ALL_STUDENTS_FAILURE,
  GET_ACTIVE_STUDENTS,
  GET_ACTIVE_STUDENTS_SUCCESS,
  GET_ACTIVE_STUDENTS_FAILURE,
  GET_STUDENTS_ANALYTICS,
  GET_STUDENTS_ANALYTICS_SUCCESS,
  GET_STUDENTS_ANALYTICS_FAILURE,
  GET_STUDENT_DETAILS,
  GET_STUDENT_DETAILS_SUCCESS,
  GET_STUDENT_DETAILS_FAILURE,
  UPDATE_STUDENT,
  UPDATE_STUDENT_SUCCESS,
  UPDATE_STUDENT_FAILURE,
} from "../constants";

export default class StudentAction {
  static getAllStudents(payload, cb) {
    return {
      type: GET_ALL_STUDENTS,
      payload,
      cb,
    };
  }
  static getAllStudentsSuccess(payload) {
    return {
      type: GET_ALL_STUDENTS_SUCCESS,
      payload,
    };
  }
  static getAllStudentsFailure(payload) {
    return {
      type: GET_ALL_STUDENTS_FAILURE,
      payload,
    };
  }
  static getStudentsAnalytics(payload, cb) {
    return {
      type: GET_STUDENTS_ANALYTICS,
      payload,
      cb,
    };
  }
  static getStudentsAnalyticsSuccess(payload) {
    return {
      type: GET_STUDENTS_ANALYTICS_SUCCESS,
      payload,
    };
  }
  static getStudentsAnalyticsFailure(payload) {
    return {
      type: GET_STUDENTS_ANALYTICS_FAILURE,
      payload,
    };
  }
  static getActiveStudents(payload, cb) {
    return {
      type: GET_ACTIVE_STUDENTS,
      payload,
      cb,
    };
  }
  static getActiveStudentsSuccess(payload) {
    return {
      type: GET_ACTIVE_STUDENTS_SUCCESS,
      payload,
    };
  }
  static getActiveStudentsFailure(payload) {
    return {
      type: GET_ACTIVE_STUDENTS_FAILURE,
      payload,
    };
  }
  static getStudentDetails(payload, cb) {
    return {
      type: GET_STUDENT_DETAILS,
      payload,
      cb,
    };
  }
  static getStudentDetailsSuccess(payload) {
    return {
      type: GET_STUDENT_DETAILS_SUCCESS,
      payload,
    };
  }
  static getStudentDetailsFailure(payload) {
    return {
      type: GET_STUDENT_DETAILS_FAILURE,
      payload,
    };
  }
  static updateStudent(payload, cb) {
    return {
      type: UPDATE_STUDENT,
      payload,
      cb,
    };
  }
  static updateStudentSuccess(payload) {
    return {
      type: UPDATE_STUDENT_SUCCESS,
      payload,
    };
  }
  static updateStudentFailure(payload) {
    return {
      type: UPDATE_STUDENT_FAILURE,
      payload,
    };
  }
}
